module.exports = __webpack_public_path__ + "static/video-poster-0ec58211ee7511b48084ec3cf3adc319.png";